module.exports = __webpack_public_path__ + "img/ele-closed.746f6b3b.jpeg";